import EditSelectorList from './EditSelectorList';

export default EditSelectorList;
